//'resources/css/app.css'

import './bootstrap';
import '../js/capturaParams'
const isProduction = import.meta.env.PROD;

// Import Chart.js
import { Chart, Tooltip } from 'chart.js';

// Import flatpickr
import flatpickr from 'flatpickr';

// Import Sweetaler2

// Import AOS
import 'aos/dist/aos.css'
import Aos from 'aos';
Aos.init();





// import component from './components/component';
const dashboardCard01 = () => import('./components/dashboard-card-01');
const dashboardCard02 = () => import('./components/dashboard-card-02');
const dashboardCard03 = () => import('./components/dashboard-card-03');
const dashboardCard04 = () => import('./components/dashboard-card-04');
const dashboardCard05 = () => import('./components/dashboard-card-05');
const dashboardCard06 = () => import('./components/dashboard-card-06');
const dashboardCard08 = () => import('./components/dashboard-card-08');
const dashboardCard09 = () => import('./components/dashboard-card-09');
const dashboardCard11 = () => import('./components/dashboard-card-11');

Chart.register(Tooltip, {
  id: 'chartAreaPlugin',
  // eslint-disable-next-line object-shorthand
  beforeDraw: (chart) => {
    if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
      const ctx = chart.canvas.getContext('2d');
      const { chartArea } = chart;
      ctx.save();
      ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
      // eslint-disable-next-line max-len
      ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
      ctx.restore();
    }
  },
});

// 2. SEGUNDO: Ahora que todo está registrado, modificamos los defaults de forma segura
/* eslint-disable prefer-destructuring */
Chart.defaults.font.family = '"Inter", sans-serif';
Chart.defaults.font.weight = '500';

// Aseguramos la estructura por si acaso la versión cambia sutilmente
Chart.defaults.plugins = Chart.defaults.plugins || {};
Chart.defaults.plugins.tooltip = Chart.defaults.plugins.tooltip || {};

Chart.defaults.plugins.tooltip.borderWidth = 1;
Chart.defaults.plugins.tooltip.displayColors = false;
Chart.defaults.plugins.tooltip.mode = 'nearest';
Chart.defaults.plugins.tooltip.intersect = false;
Chart.defaults.plugins.tooltip.position = 'nearest';
Chart.defaults.plugins.tooltip.caretSize = 0;
Chart.defaults.plugins.tooltip.caretPadding = 20;
Chart.defaults.plugins.tooltip.cornerRadius = 4;
Chart.defaults.plugins.tooltip.padding = 8;

document.addEventListener('DOMContentLoaded', () => {
  // Light switcher
  const lightSwitches = document.querySelectorAll('.light-switch');
  if (lightSwitches.length > 0) {
    lightSwitches.forEach((lightSwitch, i) => {
      if (localStorage.getItem('dark-mode') === 'true') {
        lightSwitch.checked = true;
      }
      lightSwitch.addEventListener('change', () => {
        const { checked } = lightSwitch;
        lightSwitches.forEach((el, n) => {
          if (n !== i) {
            el.checked = checked;
          }
        });
        document.documentElement.classList.add('[&_*]:!transition-none');
        if (lightSwitch.checked) {
          document.documentElement.classList.add('dark');
          document.querySelector('html').style.colorScheme = 'dark';
          localStorage.setItem('dark-mode', true);
          document.dispatchEvent(new CustomEvent('darkMode', { detail: { mode: 'on' } }));
        } else {
          document.documentElement.classList.remove('dark');
          document.querySelector('html').style.colorScheme = 'light';
          localStorage.setItem('dark-mode', false);
          document.dispatchEvent(new CustomEvent('darkMode', { detail: { mode: 'off' } }));
        }
        setTimeout(() => {
          document.documentElement.classList.remove('[&_*]:!transition-none');
        }, 1);
      });
    });
  }
  // Flatpickr
  flatpickr('.datepicker', {
    mode: 'range',
    static: true,
    monthSelectorType: 'static',
    dateFormat: 'M j, Y',
    defaultDate: [new Date().setDate(new Date().getDate() - 6), new Date()],
    prevArrow: '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M5.4 10.8l1.4-1.4-4-4 4-4L5.4 0 0 5.4z" /></svg>',
    nextArrow: '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M1.4 10.8L0 9.4l4-4-4-4L1.4 0l5.4 5.4z" /></svg>',
    onReady: (selectedDates, dateStr, instance) => {
      // eslint-disable-next-line no-param-reassign
      instance.element.value = dateStr.replace('to', '-');
      const customClass = instance.element.getAttribute('data-class');
      instance.calendarContainer.classList.add(customClass);
    },
    onChange: (selectedDates, dateStr, instance) => {
      // eslint-disable-next-line no-param-reassign
      instance.element.value = dateStr.replace('to', '-');
    },
  });
  
  dashboardCard01().then(module => module.default());
  dashboardCard02().then(module => module.default());
  dashboardCard03().then(module => module.default());
  dashboardCard04().then(module => module.default());
  dashboardCard05().then(module => module.default());
  dashboardCard06().then(module => module.default());
  dashboardCard08().then(module => module.default());
  dashboardCard09().then(module => module.default());
  dashboardCard11().then(module => module.default());
});


